module.exports = __webpack_public_path__ + "static/NimbusSanL-Bold-b55dfa1e48776fbe0103f2cc4101358b.woff2";